export default __webpack_public_path__ + "static/media/LOGOs.61098b7c.svg";